import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-instructor-bottom-nav',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './instructor-bottom-nav.component.html',
  styleUrl: './instructor-bottom-nav.component.scss',
})
export class InstructorBottomNavComponent {
  private authService = inject(AuthService);

  get userId(): string | undefined {
    return this.authService.userSig()?.id;
  }

  logout(): void {
    this.authService.logout();
  }
}
